import { mountRootParcel } from 'single-spa';
import Parcel from 'single-spa-react/parcel';
import { useContext } from 'react';
import { UserContext } from '@adflow/utils';

export function Index() {
  const { user } = useContext(UserContext);
  return (
    <div>
      <Parcel
        config={() => import('creative-hub-vue/App')}
        wrapWith="div"
        wrapStyle={{ height: '100%' }}
        routerBasePath={'/'}
        handleError={(err) => console.log(err)}
        mountParcel={mountRootParcel}
        parcelDidMount={() => console.log('video-tags parcel mounted')}
        user={user}
      />
    </div>
  );
}
